import * as api from '../../services/api';

export default {
  data() {
    return {
      overdueWorkOrderList: [],
      currentSort: 'OverdueDay',
      currentSortDir: 'desc',
      pageSize: 6,
      currentPage: 1,
    };
  },
  mounted() {
    api.getOverdueWorkOrders().then((res) => {
        this.overdueWorkOrderList = res.body.map(woItem => {
            return {
                Id: woItem.Id,
                Name: woItem.Name,
                StatusName: woItem.StatusName,
                ScheduledTime: moment(woItem.ScheduledTime).format('DD-MM-YYYY'),
                OverdueDay: woItem.OverdueDay
            };
        });
    });
  },
  methods: {
    redraw() {
    },
    sort(s) {
      if (s === this.currentSort) {
        this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc';
      }
      this.currentSort = s;
    },
    nextPage() {
      if (this.currentPage * this.pageSize < this.overdueWorkOrderList.length) this.currentPage++;
    },
    prevPage() {
      if (this.currentPage > 1) this.currentPage--;
    },
    openWorkOrder(id) {
        const router = { name: 'MyWorkOrder', query: { from: 'WorkOrderList', 'workOrderId': id } }; //{ name: 'AddWorkOrder', query: { 'workOrderId': dataList[0].Id ? dataList[0].Id.toString() : '' } };
        const routeData = this.$router.resolve(router);
        window.open(routeData.href, '_blank');
    }
  },
  computed: {
    sortedOverdueWorkOrderList() {
      return this.overdueWorkOrderList.sort((a, b) => {
        let modifier = 1;
        if (isNaN(a[this.currentSort]) || isNaN(b[this.currentSort])) {
          const compare = a[this.currentSort].localeCompare(b[this.currentSort]);
          if (this.currentSortDir === 'asc') modifier = -1;
          if (compare > 0) return -1 * modifier;
          if (compare < 0) return 1 * modifier;
        } else {
          if (this.currentSortDir === 'asc') modifier = -1;
          if (a[this.currentSort] > b[this.currentSort]) return -1 * modifier;
          if (a[this.currentSort] < b[this.currentSort]) return 1 * modifier;
        }
        return 0;
      }).filter((row, index) => {
        const start = (this.currentPage - 1) * this.pageSize;
        const end = this.currentPage * this.pageSize;
        if (index >= start && index < end) return true;
      });
    },
    isLastPage() {
      return this.currentPage * this.pageSize >= this.overdueWorkOrderList.length;
    },
    isFirstPage() {
      return this.currentPage == 1;
    },
  },
};
